export default {"src":"/_next/static/media/unit_info.20a3e6db.svg","height":44,"width":44};